// reportListConstants.js

export const LIMIT_PER_PAGE = 50;
export const PURGE_THRESHOLD_MONTHS = 3;
export const MAX_REPORTS_TO_KEEP = 100;
export const REPORT_TYPES_CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

export const DATE_FILTERS = {
  TODAY: 'today',
  TWO_DAYS: '2days',
  THREE_DAYS: '3days',
  ONE_WEEK: '1week',
  UNREAD: 'unread',
  ALL: 'all'
};

export const SMALL_SCREEN_BREAKPOINT = 950;